export const CURR_API = process.env.VUE_APP_KEYON_PATH || '/keyon';
export const OTHER_API = process.env.VUE_APP_PACMNY_BE_API || '/pacmny-be';
